export default __webpack_public_path__ + "static/media/No_image.462e1efa.png";